export default "__VITE_ASSET__DLI7Rong__"